; (function (angular, _) {
  'use strict'

  angular.module('kilo.common.services')
    .factory('$xhrFactory', function () {
      return function createXhr (method, url) {
        const xhr = new window.XMLHttpRequest()
        if (url.includes('filters') || url.includes('quotes/filters') || url.includes('bpu')) {
          xhr.timeout = 12000
        } else {
          xhr.timeout = 30000
        }
        return xhr
      }
    })
})(window.angular, window._)
